import Vue from 'vue'
import axios from 'axios'

var VueCookie = require('vue-cookie');
Vue.use(VueCookie);

const cookieName = 'DEMANDSCALE-SESSION-ID';
// const baseUrl = 'http://localhost:8888/';
const baseUrl = 'https://ds-api.prod.sift.co/';

function getParam(name) {
    const url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function getBasicConfig(contentType = 'application/json') {
    return {crossdomain: true, headers: {'Content-Type': contentType}}
}

function getSessionIdConfig(contentType = 'application/json') {
    return {crossdomain: true, headers: {'Content-Type': contentType, 'x-demandscale-session-id': getSessionId()}}
}

function getSessionId() {
    return VueCookie.get(cookieName);
}

function setSessionId(response) {
    if (response.data.session_id) {
        VueCookie.set(cookieName, response.data.session_id, {expires: '1Y'});
    }
}

function navigateToPage(page, params) {
    if (!params) {
        window.location.href = page;
    } else {
        var c = '?';
        if (page.indexOf('?') > 0) {
            c = '&';
        }
        window.location.href = page + c + params;
    }
}

function navigateToLoginPage() {
    const path = window.location.href.split('/').pop();
    navigateToPage('login.html', 'redirect=' + encodeURIComponent(path));
}

function clearSession() {
    VueCookie.delete(cookieName);
}

function responseHandler(response, successHandler, errorHandler, errors) {
    errors.splice(0, errors.length);
    if (response.data && (response.data.success === true || !response.data.error_codes)) {
        successHandler(response.data);
    } else if (response.data && response.data.error_codes && response.data.error_codes.length > 0) {
        errorHandler();
        if (response.data.error_codes.indexOf('NO_SESSION') >= 0) {
            navigateToLoginPage();
        } else {
            for (let i = 0; i < response.data.error_codes.length; i++) {
                errors.push(response.data.error_codes[i]);
            }
        }
    } else {
        errorHandler();
        errors.push('UNKNOWN_ERROR');
    }
}

function exceptionHandler(exception, errors) {
    errors.splice(0, errors.length);
    if (!exception) {
        errors.push('UNKNOWN_ERROR');
    } else {
        errors.push(exception.toString());
    }
}

export default {
    baseUrl: baseUrl,

    getParam: function (name, defaultValue) {
        const value = getParam(name);
        if (value == null) {
            return defaultValue;
        } else {
            return value;
        }
    },

    navigateToPage(page, params) {
        navigateToPage(page, params);
    },

    getSessionId() {
        return getSessionId();
    },

    checkSession() {
        if (!getSessionId()) {
            navigateToLoginPage();
        } else {
            axios.get(baseUrl + 'check_session', getSessionIdConfig())
                .then(response => {
                    if (response.data && response.data.error_codes && response.data.error_codes.indexOf('NO_SESSION') >= 0) {
                        navigateToLoginPage();
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .catch(error => {
                    navigateToLoginPage();
                });
        }
    },

    hasSession(callback) {
        if (!getSessionId()) {
            callback(false);
        } else {
            axios.get(baseUrl + 'check_session', getSessionIdConfig())
                .then(response => {
                    if (response.data && response.data.error_codes && response.data.error_codes.indexOf('NO_SESSION') >= 0) {
                        callback(false);
                    } else {
                        callback(true);
                    }
                })
                // eslint-disable-next-line no-unused-vars
                .catch(error => {
                    callback(false);
                });
        }
    },

    login(data, successHandler, errorHandler, errors) {
        axios.post(baseUrl + 'login', data, getBasicConfig())
            .then(response => {
                setSessionId(response);
                responseHandler(response, successHandler, errorHandler, errors);
            })
            .catch(e => {
                exceptionHandler(e, errors);
                errorHandler();
            });
    },

    signup(data, successHandler, errorHandler, errors, contentType) {
        axios.post(baseUrl + 'signup', data, getBasicConfig(contentType))
            .then(response => {
                clearSession();
                responseHandler(response, successHandler, errorHandler, errors);
            })
            .catch(e => {
                exceptionHandler(e, errors);
                errorHandler();
            });
    },

    resetPassword(data, successHandler, errorHandler, errors, contentType) {
        axios.post(baseUrl + 'reset_password', data, getBasicConfig(contentType))
            .then(response => {
                setSessionId(response);
                responseHandler(response, successHandler, errorHandler, errors);
            })
            .catch(e => {
                exceptionHandler(e, errors);
                errorHandler();
            });
    },

    logout(successHandler, errorHandler) {
        axios.get(baseUrl + 'logout', getSessionIdConfig())
            .then(response => {
                clearSession();
                responseHandler(response, successHandler, errorHandler, []);
            })
            // eslint-disable-next-line no-unused-vars
            .catch(e => {
                errorHandler()
            });
    },

    get(endpoint, successHandler, errorHandler, errors, contentType) {
        axios.get(baseUrl + endpoint, getSessionIdConfig(contentType))
            .then(response => {
                responseHandler(response, successHandler, errorHandler, errors);
            })
            .catch(e => {
                exceptionHandler(e, errors);
                errorHandler();
            });
    },

    put(endpoint, data, successHandler, errorHandler, errors, contentType) {
        axios.put(baseUrl + endpoint, data, getSessionIdConfig(contentType))
            .then(response => {
                responseHandler(response, successHandler, errorHandler, errors);
            })
            .catch(e => {
                exceptionHandler(e, errors);
                errorHandler();
            });
    },

    post(endpoint, data, successHandler, errorHandler, errors, contentType) {
        axios.post(baseUrl + endpoint, data, getSessionIdConfig(contentType))
            .then(response => {
                responseHandler(response, successHandler, errorHandler, errors);
            })
            .catch(e => {
                exceptionHandler(e, errors);
                errorHandler();
            });
    }
};